var render = function render(){
  var _vm$unscannedQuantity;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm.hasErrorCheckingStepAllowed ? _c('div', [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_c('p', [_vm._v(" Er is iets fout gegaan bij de controle of dit product meerdere malen mag worden toegevoegd aan de order."), _c('br'), _vm._v(" Voeg "), _c('span', {
    staticClass: "font-size-xlg"
  }, [_vm._v("alleen het gescande item")]), _vm._v(" toe aan de order en ga door. ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("Volgende")])], 1)], 1) : _c('div', [_c('p', [_vm._v(" Je kan "), _c('strong', {
    staticClass: "font-size-xlg"
  }, [_vm._v(_vm._s((_vm$unscannedQuantity = _vm.unscannedQuantityInLine) !== null && _vm$unscannedQuantity !== void 0 ? _vm$unscannedQuantity : 'onbekend'))]), _vm._v(" van het gescande product "), _vm.dispatchRequest ? _c('span', [_vm._v(" toevoegen aan deze order. Geef aan hoeveel je er wilt toevoegen: ")]) : _c('span', [_vm._v(" verwerken. Geef aan hoeveel je er wilt verwerken: ")])]), _c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.save.apply(null, arguments);
      }
    }
  }, [_c('b-input', {
    ref: "valueInput",
    staticClass: "d-inline-block",
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "min": "1",
      "max": _vm.unscannedQuantityInLine,
      "autofocus": ""
    },
    model: {
      value: _vm.quantityToAdd,
      callback: function ($$v) {
        _vm.quantityToAdd = _vm._n($$v);
      },
      expression: "quantityToAdd"
    }
  }), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Toevoegen")])], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }